import React from 'react';

import { LineChartIcon } from 'lucide-react';

import { Button } from 'components/ui/button';

const ABTestEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center h-full py-10">
      <div className="mb-4 text-gray-300">
        <LineChartIcon className="w-32 h-32" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 m-4">Discover Your A/B Test Insights</h3>
      <p className="max-w-md text-sm text-gray-500 mb-6">
        To begin, choose an <b>attribute</b> from your data
        and specify the <b>values</b> you'd like to compare in order to generate your A/B test analytics
      </p>
      <Button className="p-6 cursor-default text-base-cardForeground">Select Attributes to Begin</Button>
    </div>
  );
};

export default ABTestEmptyState; 